import { Component } from '@angular/core';
import { PatientApi } from '@core/apis/patient/patient.api';
import { ICompletion } from '@core/interfaces/interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CreatePasswordFormComponent } from '../../components/create-password-form/create-password-form.component';

@Component({
  selector: 'app-completion-registration',
  imports: [CreatePasswordFormComponent],
  templateUrl: './completion-registration.component.html',
  styleUrl: './completion-registration.component.scss',
})
@UntilDestroy()
export class CompletionRegistrationComponent {
  public success: boolean = false;
  constructor(private readonly patientApi: PatientApi) {}

  completion(data: ICompletion): void {
    this.patientApi
      .patientCompletion(data)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.success = true;
      });
  }
}
